import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface ReportsEditorNavigationComponentInterface {
	Args: {
		onAddSlide: (e: PointerEvent) => void;
	};
}

const ReportsEditorNavigationComponent: TOC<ReportsEditorNavigationComponentInterface> = <template>
	<a class="open" {{on "click" @onAddSlide}}>
		<div class="border">
			<span class="type--selector">
				<CommonUiIcon @name="ChevronDown" @size="sm" /><em></em>
			</span>
			<span class="type--default">+<em></em></span>
		</div>
	</a>
</template>;

export default ReportsEditorNavigationComponent;
